import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Formik, withFormik } from 'formik'
import Yup from 'yup'
import { creditcardDetector } from 'utils'
import { URLS } from 'containers/constants'
import { Button } from 'components'
import { getPayment } from 'rootReducer'
import { setPaymentDetails } from './actions'
import { PaymentForm } from './PaymentForm'
import messages from './messages'

class PaymentContainer extends Component {
  static propTypes = {
    touched: PropTypes.object,
    errors: PropTypes.object,
    handleBlur: PropTypes.func,
    handleChange: PropTypes.func,
    updateRoute: PropTypes.func,
    setPaymentDetails: PropTypes.func,
    payment: PropTypes.shape({
      cardType: PropTypes.string.isRequired,
      cardNumber: PropTypes.string.isRequired,
      expiryDate: PropTypes.string.isRequired,
      cvv: PropTypes.string.isRequired,
    }),
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }),
  }
  constructor(props) {
    super(props)
    this.state = {
      fields: {
        [messages.paymentType.sid]: 'creditCard',
        [messages.cardType.sid]: props.payment.cardType || '',
        [messages.cardNumber.sid]: props.payment.cardNumber || '',
        [messages.expiryDate.sid]: props.payment.expiryDate || '',
        [messages.cvv.sid]: props.payment.cvv || '',
      },
    }
  }

  /* Check if parameter year is the same as the current year or in the future */
  isYearValid = (value = '') => {
    /* Do not run validation until user has entered full expiry */
    if (value.length !== 4) return false
    const today = new Date()
    const currentYY = parseInt(today.getFullYear().toString().slice(2), 10) // ok
    const expiryYY = parseInt(value.slice(2), 10) //
    /* Get month values */
    const currentMM = today.getUTCMonth() + 1
    const expiryMM = parseInt(value.slice(0, 2), 10)
    /* If expiry month over 12 months then return early */
    if (expiryMM > 12) return false
    /* If expiry year is future return true */
    if (expiryYY > currentYY) return true
    /* If expiry year is current year and expiry month is current or future return true */
    if (expiryYY === currentYY && expiryMM >= currentMM) return true
    /* Expiry month is in the past, return false */
    return false
  }

  isCardValid = (value = '') => {
    const detectedCreditCard = creditcardDetector(value)
    if (detectedCreditCard) return true
    return false
  }

  handleValidation = values => (
    Yup.object().shape({

      [messages.cardNumber.sid]: Yup.string()
        .required(this.props.intl.formatMessage({ id: messages.cardNumberValidationEmpty.id }))
        .test('is-card-valid', this.props.intl.formatMessage({ id: messages.cardNumberInvalid.id }), this.isCardValid),

      [messages.expiryDate.sid]: Yup.string()
        .test('is-expiry-valid', this.props.intl.formatMessage({ id: messages.expiryDateError.id }), this.isYearValid),

      [messages.cvv.sid]: Yup.string()
        .required(this.props.intl.formatMessage({ id: messages.cvvValidationEmpty.id }))
        .min(3, this.props.intl.formatMessage({ id: messages.cvvValidationMinLength.id })),
    })
  )

  handleSubmit = (values, props) => {
    this.props.setPaymentDetails(values)
    this.props.updateRoute(URLS.CHAT, URLS.REVIEW)
  }

  render() {
    const {
      props: {
        touched, errors, handleBlur, handleChange,
      },
    } = this
    return (<Formik
      initialValues={this.state.fields}
      onSubmit={this.handleSubmit}
      render={props => <PaymentForm {...props} {...this.props} />}
      validationSchema={this.handleValidation}
      displayName="Payment Form"
    />)
  }
}

const mapDispatchToProps = {
  setPaymentDetails,
}

const mapStateToProps = state => ({
  payment: getPayment(state),
})

/* Using compose so we can clearly see what the AddressContainer is being enhanced with */
export const ConnectedPaymentContainer = compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(PaymentContainer)



// WEBPACK FOOTER //
// ./src/containers/Cart/Payment/PaymentContainer.js